import { emptyFragment } from '@execonline-inc/execonline-ui';
import { AlreadyTranslated } from '@execonline-inc/translations';
import { fromEmpty, Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { HtmlView } from '../../../../Common/Experience';
import {
  ExperienceDisplayTypeKind,
  ExperienceResources,
  ProductCollection,
} from '../../../../Common/Experience/Types';
import {
  ExperienceSection,
  ExperienceSectionBody,
  ExperienceSectionHeader,
  ExperienceSectionTitle,
} from '../../../Common/ExperienceSection';
import EnrollmentStore from '../../../Enrollment/Store';
import { useExperienceFilters } from '../../Filters/FiltersContext';
import TileExperiences from './TileExperiences';
import ExpandExperiences from '../ExpandExperiences';

interface Props {
  kind: ExperienceDisplayTypeKind;
  invitationUuid: string;
  productCollection: Maybe<ProductCollection>;
  experienceResources: ExperienceResources;
  enrollmentStore: EnrollmentStore;
}

function TileViewExperiences({
  invitationUuid,
  experienceResources,
  enrollmentStore,
  kind,
  productCollection,
}: Props) {
  const { filterExperienceResources } = useExperienceFilters();

  const filteredExperienceResources = filterExperienceResources(experienceResources);

  switch (kind) {
    case 'experiences':
      return fromEmpty(filteredExperienceResources)
        .map((resources) => (
          <ExperienceSection className="bg-inherit pb-6 pt-0 !shadow-none sm:py-8">
            <ExperienceSectionHeader>
              <ExperienceSectionTitle>
                <T kind="All Courses in this Catalog" />
              </ExperienceSectionTitle>
            </ExperienceSectionHeader>
            <ExperienceSectionBody>
              <TileExperiences
                invitationUuid={invitationUuid}
                experienceResources={resources}
                enrollmentStore={enrollmentStore}
              />
            </ExperienceSectionBody>
          </ExperienceSection>
        ))
        .getOrElse(emptyFragment);
    case 'product-collection':
      return productCollection
        .map((pc) => (
          <ExperienceSection className="bg-inherit pb-6 pt-0 !shadow-none sm:py-8">
            <ExperienceSectionHeader>
              <ExperienceSectionTitle>
                <AlreadyTranslated content={pc.name} />
              </ExperienceSectionTitle>
              {pc.description
                .map((description) => (
                  <HtmlView
                    description={description}
                    className="mt-4 !text-sm leading-normal text-black sm:!text-lg"
                  />
                ))
                .getOrElse(emptyFragment)}
            </ExperienceSectionHeader>
            <ExperienceSectionBody>
              <ExpandExperiences displayButtonLabel={pc.displayButtonLabel}>
                <TileExperiences
                  invitationUuid={invitationUuid}
                  experienceResources={filteredExperienceResources}
                  enrollmentStore={enrollmentStore}
                />
              </ExpandExperiences>
            </ExperienceSectionBody>
          </ExperienceSection>
        ))
        .getOrElse(emptyFragment);
  }
}

export default observer(TileViewExperiences);
